import { colors } from '@/theme/colors';
import { cn } from '@/shadcn-ui/utils';

export interface BannerInfoProps {
  className?: string;
}

export default function BannerInfo({ className }: BannerInfoProps) {
  return (
    <svg
      viewBox="0 0 28 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(`h-[36px] w-[28px]`, className)}
    >
      <g filter="url(#filter0_d_3223_6879)">
        <path
          d="M7 14C7 9.58172 10.5817 6 15 6C19.4183 6 23 9.58172 23 14V22C23 26.4183 19.4183 30 15 30C10.5817 30 7 26.4183 7 22V14Z"
          fill="url(#paint0_linear_3223_6879)"
        />
        <path
          d="M7.5 14C7.5 9.85786 10.8579 6.5 15 6.5C19.1421 6.5 22.5 9.85786 22.5 14V22C22.5 26.1421 19.1421 29.5 15 29.5C10.8579 29.5 7.5 26.1421 7.5 22V14Z"
          stroke={colors.blue60}
          strokeMiterlimit="10"
        />
      </g>
      <g filter="url(#filter1_d_3223_6879)">
        <circle cx="15" cy="14" r="1.5" fill={colors.neutral100} />
      </g>
      <g filter="url(#filter2_d_3223_6879)">
        <rect x="13.5" y="17.5" width="3" height="7" rx="1.5" fill={colors.neutral100} />
      </g>
      <defs>
        <filter
          id="filter0_d_3223_6879"
          x="0"
          y="0"
          width="28"
          height="36"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.258824 0 0 0 0 0.286275 0 0 0 0 1 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3223_6879"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3223_6879"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3223_6879"
          x="9.5"
          y="10.5"
          width="11"
          height="11"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3223_6879"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3223_6879"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_3223_6879"
          x="9.5"
          y="15.5"
          width="11"
          height="15"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3223_6879"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3223_6879"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3223_6879"
          x1="9.66667"
          y1="7.6"
          x2="24.5296"
          y2="21.8207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.blue40} />
          <stop offset="1" stopColor={colors.blue60} />
        </linearGradient>
      </defs>
    </svg>
  );
}
